module.exports = __webpack_public_path__ + "media/images/MR_HP_top-fb4bb5f0.png";